import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { routes } from '@app/consts';
import { SanitiseGridDataService } from '@app/core/services/sanitise-grid-data/sanitise-grid-data.service';
import { TranslateService } from '@ngx-translate/core';
import { ExcelExportEvent, GridComponent, GridDataResult, PageChangeEvent, PageSizeItem } from '@progress/kendo-angular-grid';
import { SortDescriptor, State } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { OutstandingAbsenceReportService } from '../../services/outstanding-absence-report.service';
import { AbsenceRecord } from '@app/modules/reports/components/absence-report/models/absence-report.model';
import moment from 'moment';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { GridState } from '@app/shared/services/grid-state/grid-state.model';

@Component({
    selector: 'app-outstanding-absence-details-data-grid',
    templateUrl: './outstanding-absence-report-details-data-grid.component.html',
    styleUrls: ['./outstanding-absence-report-details-data-grid.component.scss']
})
export class OutstandingAbsenceReportDetailsDataGridComponent implements OnInit {
    @ViewChild('excelexport') excelexport: any;
    public grid: GridComponent;
    public routes: typeof routes = routes;
    public bindingType = 'array';
    public gridDataResult: GridDataResult;
    excelData: any;
    gridId: string = 'OutstandingAbsenceReportDetailsDataGrid';
    isLoading: boolean;
    pageSize: number = 20;
    skip: number = 0;

    sortString: string;
    filterString: string;
    filterToggleDetails: {
        text: string,
        checked: boolean
    } = {
            text: 'FilterInactive',
            checked: true
        }

    excelColumns: any[] = [
        { field: 'customClientId', title: this.translate.instant('OutstandingAbsenceFinanceReport-CustomClientId') },
        { field: 'firstName', title: this.translate.instant('OutstandingAbsenceFinanceReport-FirstName') },
        { field: 'lastName', title: this.translate.instant('OutstandingAbsenceFinanceReport-LastName') },
        { field: 'timeOffTypeName', title: this.translate.instant('OutstandingAbsenceFinanceReport-TimeOffType')},
        { field: 'timeOffPolicy', title: this.translate.instant('OutstandingAbsenceFinanceReport-PolicyName') },
        { field: 'availableHours', title: this.translate.instant('OutstandingAbsenceFinanceReport-OutstandingBalance') },
    ];

    public columns: any[] = [
        { field: 'customClientId', title: this.translate.instant('OutstandingAbsenceFinanceReport-CustomClientId'), localizationCode: 'OutstandingAbsenceFinanceReport-CustomClientId'  },
        { field: 'firstName', title: this.translate.instant('OutstandingAbsenceFinanceReport-FirstName'), localizationCode: 'OutstandingAbsenceFinanceReport-FirstName' },
        { field: 'lastName', title: this.translate.instant('OutstandingAbsenceFinanceReport-LastName'), localizationCode: 'OutstandingAbsenceFinanceReport-LastName' },
        { field: 'timeOffTypeName', title: this.translate.instant('OutstandingAbsenceFinanceReport-TimeOffType'), localizationCode: 'OutstandingAbsenceFinanceReport-TimeOffType' },
        { field: 'timeOffPolicy', subField: 'name', title: this.translate.instant('OutstandingAbsenceFinanceReport-PolicyName'), localizationCode: 'OutstandingAbsenceFinanceReport-PolicyName' },
        { field: 'availableHours', title: this.translate.instant('OutstandingAbsenceFinanceReport-OutstandingBalance'), localizationCode: 'OutstandingAbsenceFinanceReport-OutstandingBalance' },
    ];

    sortableColumns: any[] = [
        { field: 'customClientId', sortValue: 'employee.customClientId' },
        { field: 'firstName', sortValue: 'employee.firstName' },
        { field: 'lastName', sortValue: 'employee.lastName' },
        { field: 'timeOffTypeName', sortValue: 'timeOffType.name' },
        { field: 'timeOffPolicy', sortValue: 'timeOffType.policy.name' },
        { field: 'availableHours', sortValue: 'availableHours' },
    ];

    filterCategories: any[] = [
        { field: "employee.customClientId", title: this.translate.instant('OutstandingAbsenceFinanceReport-CustomClientId'), type: "String", dataType: 'String' },
        { field: "employee.firstName", title: this.translate.instant('OutstandingAbsenceFinanceReport-FirstName'), type: "String", dataType: 'String' },
        { field: "employee.lastName", title: this.translate.instant('OutstandingAbsenceFinanceReport-LastName'), type: "String", dataType: 'String' },
        { field: "timeOffType.name", title: this.translate.instant('OutstandingAbsenceFinanceReport-TimeOffType'), type: "String", dataType: 'String' },
        { field: "timeOffType.policy.name", title: this.translate.instant('OutstandingAbsenceFinanceReport-PolicyName'), type: "String", dataType: 'String' },
        { field: "availableHours", title: this.translate.instant('OutstandingAbsenceFinanceReport-OutstandingBalance'), type: "String", dataType: 'Number' },
        { field: "employee.status.id", title: this.translate.instant('Employee-Status'), dataType: "ProvidedList", listOptions: {
            list: [
                {id: 'Active', name: this.translate.instant('Employee-Status-Active')}, 
                {id: 'InActive', name: this.translate.instant('Employee-Status-InActive')},
                {id: 'Future', name: this.translate.instant('Employee-Status-Future')},
            ],
            id: 'id',
            name: 'name'
        }},
    ];

    searchValue: any;
    searchFilterString: string;
    getRequest: any;
    error: boolean;
    showAsOfDateField: boolean = true;
    asOfDate: any = moment().format('YYYY-MM-DD');
    fileName: string = this.translate.instant('OutstandingAbsenceReport') + '_' + moment().format('YYYY-MM-DD') + '.xlsx';

    // public columns: any[] = [
    //     {
    //         field: 'id', title: this.translate.instant('OutstandingAbsenceFinanceReport-Id')
    //         , tableId: 'OutstandingAbsenceFinanceReport-Id', dataType: 'String'
    //     },
    //     {
    //         field: 'firstName', title: this.translate.instant('OutstandingAbsenceFinanceReport-FirstName')
    //         , tableId: 'OutstandingAbsenceFinanceReport-FirstName', dataType: 'String'
    //     },
    //     {
    //         field: 'lastName', title: this.translate.instant('OutstandingAbsenceFinanceReport-LastName')
    //         , tableId: 'OutstandingAbsenceFinanceReport-LastName', dataType: 'String'
    //     },
    //     {
    //         field: 'timeOffPolicy.name', title: this.translate.instant('OutstandingAbsenceFinanceReport-PolicyName')
    //         , tableId: 'OutstandingAbsenceFinanceReport-PolicyName', dataType: 'String'
    //     },
    //     {
    //         field: 'outstandingBalance', title: this.translate.instant('OutstandingAbsenceFinanceReport-OutstandingBalance')
    //         , tableId: 'OutstandingAbsenceFinanceReport-OutstandingBalance', dataType: 'decimal'
    //     },
    // ];

    constructor(
        private translate: TranslateService,
        private overlayService: OverlayService,
        private outstandingAbsenceReportService: OutstandingAbsenceReportService,
    ) {
        this.getData();

        // Bind 'this' explicitly to capture the execution context of the component.
        this.allData = this.allData.bind(this);
    }

    ngOnInit(): void {
    }

    public allData() {
        this.overlayService.show('Loading');

        from(this.outstandingAbsenceReportService.getAllReportData(this.sortString, this.filterString, this.asOfDate))
            .subscribe({
                next: (res) => {
                    this.excelData = res.data;

                    this.excelData.map((item) => {
                        item.firstName = item.employee.firstName;
                        item.lastName = item.employee.lastName;
                        item.customClientId = item.employee.customClientId;
                        item.timeOffPolicy = item.timeOffType?.policy?.name;
                        item.timeOffTypeName = item.timeOffType?.name;
                    });

                    // if I dont have this timeout first time I download the report the data will be blank
                    setTimeout(() => {
                        this.excelexport.save();
                    }, 1000);
                },
                error: (e) => {
                    this.overlayService.hide();
                },
                complete: () => this.overlayService.hide()
            });
    }

    getData(): void {
        this.isLoading = true;
        this.getRequest = this.outstandingAbsenceReportService.getReportData(this.pageSize, this.skip, this.sortString, this.filterString, this.asOfDate)
            .subscribe(
                {
                    next: (v) => {
                        this.gridDataResult = {
                            data: v.data,
                            total: v.total,
                        }

                        this.gridDataResult.data.map((item) => {
                            item.firstName = item.employee.firstName;
                            item.lastName = item.employee.lastName;
                            item.customClientId = item.employee.customClientId;
                            item.timeOffPolicy = item.timeOffType?.policy;
                            item.timeOffTypeName = item.timeOffType?.name;
                        });

                    },
                    error: (e) => {
                        this.error = true;
                        this.isLoading = false;
                    },
                    complete: () => this.isLoading = false
                }
            );
    }

    gridStateChange(gridState: GridState) {
        if (this.pageSize !== gridState.pageSize) {
            this.pageSize = gridState.pageSize;
        }
        if (this.skip !== gridState.skip) {
            this.skip = gridState.skip;
        }
        if (this.sortString !== gridState.sortString) {
            this.sortString = gridState.sortString;
        }
        if (this.filterString !== gridState.filter) {
            this.filterString = gridState.filter;
            this.skip = 0;
        }

        if (this.asOfDate !== gridState.asOfDate) {
            this.asOfDate = gridState.asOfDate;
        }

        this.getRequest.unsubscribe();
        this.getData();
    }

}
